// extracted by mini-css-extract-plugin
export var aircallIframe = "_fl-3";
export var fabContainer = "_fl-5";
export var fabRinging = "_fl-6";
export var loadingOverlay = "_fl-4";
export var pulse = "_fl-7";
export var widgetContent = "_fl-2";
export var widgetPanel = "_fl-0";
export var widgetPanelExpanded = "_fl-1";